import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProductAttributeScope, ProductCategoryAttribute} from '../../master-data/master-data.model';
import {ProductAttributeScopes, ProductCategoriesAttributes} from '../../../locale/consts.en';
import { NEW_UI_FORM_FIELD_DEFAULTS } from '../../shared/styles/new-ui-form-field';

@Component({
    selector: 'app-product-categories-attribute-edit',
    templateUrl: './product-categories-attribute-edit.component.html',
    styleUrls: ['./product-categories-attribute-edit.component.scss'],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductCategoriesAttributeEditComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  dialogRef = inject<MatDialogRef<ProductCategoriesAttributeEditComponent>>(MatDialogRef);
  /** The attribute being edited, null when adding a new one. */
  attribute = inject<ProductCategoryAttribute | null>(MAT_DIALOG_DATA, { optional: true });


  form: FormGroup;
  ProductCategoriesAtt = ProductCategoriesAttributes;
  scopes = [ProductAttributeScope.PRODUCT, ProductAttributeScope.DEVICE];
  scopeLabels = ProductAttributeScopes;


  ngOnInit(): void {
    // forms ("devAttr_<key>" columns) and formulas use the key, and the stored values follow the type
    const editing = !!this.attribute;
    this.form = this.formBuilder.group({
      name: [this.attribute?.name ?? null, [Validators.required]],
      key: [{ value: this.attribute?.key ?? null, disabled: editing }, [Validators.required]],
      sort: [this.attribute?.sort ?? 0],
      productAttributeType: [{ value: this.attribute?.productAttributeType ?? null, disabled: editing }, [Validators.required]],
      scope: [this.attribute?.scope ?? ProductAttributeScope.PRODUCT, [Validators.required]],
    });
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onSave() {
    const value = this.form.getRawValue();
    const prodAttrib = new ProductCategoryAttribute(
      value.name,
      value.key,
      value.sort ?? 0,
      value.productAttributeType,
      value.scope,
      this.attribute?.uuid,
    );

    this.dialogRef.close(prodAttrib);
  }
}
